import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import utilityService from '../../services/utilityService';

// Async thunks
export const fetchCountries = createAsyncThunk(
  'utility/fetchCountries',
  async (_, { rejectWithValue }) => {
    try {
      const response = await utilityService.getCountries();
      return response.success ? response.data : rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch countries');
    }
  }
);

export const fetchNationalities = createAsyncThunk(
  'utility/fetchNationalities',
  async (_, { rejectWithValue }) => {
    try {
      const response = await utilityService.getNationalities();
      return response.success ? response.data : rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch nationalities');
    }
  }
);

export const fetchSecurityQuestions = createAsyncThunk(
  'utility/fetchSecurityQuestions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await utilityService.getSecurityQuestions();
      return response.success ? response.data : rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch security questions');
    }
  }
);

export const fetchTimezones = createAsyncThunk(
  'utility/fetchTimezones',
  async (_, { rejectWithValue }) => {
    try {
      const response = await utilityService.getTimezones();
      return response.success ? response.data : rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch timezones');
    }
  }
);

const utilitySlice = createSlice({
  name: 'utility',
  initialState: {
    countries: [],
    nationalities: [],
    securityQuestions: [],
    timezones: [],
    loading: {
      countries: false,
      nationalities: false,
      securityQuestions: false,
      timezones: false
    },
    error: null
  },
  reducers: {
    clearUtilityError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch countries
      .addCase(fetchCountries.pending, (state) => {
        state.loading.countries = true;
        state.error = null;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.loading.countries = false;
        state.countries = action.payload;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.loading.countries = false;
        state.error = action.payload;
      })
      
      // Fetch nationalities
      .addCase(fetchNationalities.pending, (state) => {
        state.loading.nationalities = true;
        state.error = null;
      })
      .addCase(fetchNationalities.fulfilled, (state, action) => {
        state.loading.nationalities = false;
        state.nationalities = action.payload;
      })
      .addCase(fetchNationalities.rejected, (state, action) => {
        state.loading.nationalities = false;
        state.error = action.payload;
      })
      
      // Fetch security questions
      .addCase(fetchSecurityQuestions.pending, (state) => {
        state.loading.securityQuestions = true;
        state.error = null;
      })
      .addCase(fetchSecurityQuestions.fulfilled, (state, action) => {
        state.loading.securityQuestions = false;
        state.securityQuestions = action.payload;
      })
      .addCase(fetchSecurityQuestions.rejected, (state, action) => {
        state.loading.securityQuestions = false;
        state.error = action.payload;
      })
      
      // Fetch timezones
      .addCase(fetchTimezones.pending, (state) => {
        state.loading.timezones = true;
        state.error = null;
      })
      .addCase(fetchTimezones.fulfilled, (state, action) => {
        state.loading.timezones = false;
        state.timezones = action.payload;
      })
      .addCase(fetchTimezones.rejected, (state, action) => {
        state.loading.timezones = false;
        state.error = action.payload;
      });
  }
});

export const { clearUtilityError } = utilitySlice.actions;
export default utilitySlice.reducer;
